export const TEXTS_INCO = {
  es_ES: new Map([
    ['chartNameIncoEjecucion', 'EJECUCIÓN POR MESES'],
    ['chartNameIncoCapitulo', 'EJECUCIÓN MENSUAL POR CAPÍTULO'],
    ['prev_definitiva', 'Previsión Definitiva (€)'],
    ['prevision_definitiva', 'Previsión Definitiva (€)'],
    ['derechos_reconoc_netos', 'Derechos Reconocidos Netos (€)'],
    ['derechos_reconocidos_netos', 'Derechos Reconocidos Netos (€)'],
    ['real_vs_presupuestados', 'Ejecución mensual (%)'],
    ['fecha', 'Fecha'],
    ['capitulo', 'Capítulo'],
    ['subconcepto', 'Subconcepto'],
    ['prevision_inicial', 'Previsión Inicial'],
    ['modificacion_inicial', 'Modificación Inicial'],
    ['derechos_reconocidos', 'Derechos Reconocidos'],
    ['derechos_anulados', 'Derechos Anulados'],
    ['recaudacion_neta', 'Recaudación Neta'],
    ['derechos_pendientes_cobro', 'Derechos Pendientes de Cobro'],
    ['derechos_cancelados', 'Derechos Cancelados'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
  ]),
  ca_ES: new Map([
    ['chartNameIncoEjecucion', 'EXECUCIÓ PER MESOS'],
    ['chartNameIncoCapitulo', 'EXECUCIÓ MENSUAL PER CAPÍTOL'],
    ['prev_definitiva', 'Previsió Definitiva'],
    ['prevision_definitiva', 'Previsió Definitiva (€)'],
    ['derechos_reconoc_netos', 'Drets Reconeguts Nets (€)'],
    ['derechos_reconocidos_netos', 'Drets Reconeguts Nets (€)'],
    ['real_vs_presupuestados', 'Execució mensual (%)'],
    ['fecha', 'Data'],
    ['capitulo', 'Capítol'],
    ['subconcepto', 'Subconcepte'],
    ['prevision_inicial', 'Previsió Inicial'],
    ['modificacion_inicial', 'Modificació Inicial'],
    ['derechos_reconocidos', 'Drets Reconeguts'],
    ['derechos_anulados', 'Drets Anul·lats'],
    ['recaudacion_neta', 'Recaptació Neta'],
    ['derechos_pendientes_cobro', 'Drets Pendents de Cobrament'],
    ['derechos_cancelados', 'Drets Cancel·lats'],
    ['reset', 'Restablir'],
    ['download', 'Desar'],
  ]),
};
